var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, Fragment } from "react";
import TemplateForm from "./templateForm";
import withFetcher from "../../shared/fetcher";
import { getTaskTemplateFromDto, } from "../../shared/domainTypes/task/taskTemplate.type";
import Loading from "../../shared/loading";
import ActionPlanUseWarning from "../actionPlans/actionPlanUseWarning";
import TaskService from "../../../services/TaskService";
import { getTaskAdminTemplateDetailsPath } from "../../../src/View/Pages/Admin/Task/TaskTemplate/AdminTaskTemplateRoutes";
const TemplateFetcher = withFetcher("/aviso/taskAdmin/getTemplate", true)((props) => {
    if (props.fetchData) {
        const { fetchData } = props, otherProps = __rest(props, ["fetchData"]);
        const template = getTaskTemplateFromDto(fetchData);
        return (_jsxs(Fragment, { children: [template.usages &&
                    TaskService.getNumberOfActionPlansTemplateUsedIn(template) > 0 && (_jsx(ActionPlanUseWarning
                // @ts-expect-error - TS2322 - Type '{ className: string; usages: TaskTemplateUsages; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<ActionPlanUseWarning> & Readonly<Props>'.
                , { 
                    // @ts-expect-error - TS2322 - Type '{ className: string; usages: TaskTemplateUsages; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<ActionPlanUseWarning> & Readonly<Props>'.
                    className: "alert border-primary text-primary", usages: template.usages })), _jsx(TemplateForm, Object.assign({ template: template }, otherProps))] }));
    }
    if (props.fetchLoading) {
        return _jsx(Loading, { isLoading: true });
    }
    if (props.fetchHasError) {
        return _jsx("div", { className: "alert alert-danger", children: props.fetchErrorMessage });
    }
    return (_jsx("div", { children: "We did not receive any data for that template, but no errors were encoutered." }));
});
export default class TaskTemplateEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSuccess: false,
            showError: false,
            error: "",
        };
    }
    render() {
        return (_jsx(Fragment, { children: _jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsx("div", { className: "d-flex justify-content-between", children: _jsxs("h1", { className: "title", children: [_jsx("a", { href: getTaskAdminTemplateDetailsPath(this.props.match.params.templateId), className: "text-decoration-none", title: "Back to details", children: _jsx("span", { className: "fal fa-arrow-circle-left" }) }), " ", "Edit Task Template"] }) }) }), _jsxs("div", { role: "main", children: [_jsx(TemplateFetcher, { params: { id: this.props.match.params.templateId }, onSave: () => this.setState({ showSuccess: true, showError: false }), 
                                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                                onError: (error) => this.setState({ showSuccess: false, showError: true, error }), onChange: () => this.setState({ showSuccess: false, showError: false }) }), this.state.showError && (_jsx("div", { className: "alert alert-danger", children: this.state.error
                                    ? `Could not save template.  ${this.state.error}`
                                    : "There was an error saving that template" })), this.state.showSuccess && (_jsx("div", { className: "alert alert-success", children: "Template saved. " }))] })] }) }));
    }
}
